import React, { useState } from "react";
import "./Contact.css";
import Hrline from "../Hrline";
import axios from "axios";
import newspaperbg from "../../newsbannerimg.jpg";

const API_URL = process.env.REACT_APP_API_URL;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/mail`, formData);
      alert("Message sent successfully!");
      setFormData({ name: "", email: "", contact: "", message: "" });
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Failed to send message. Please try again.");
    }
  };

  return (
    <div className="main-contact-div">
      <Hrline />

      {/* Info Cards Section */}
      <div className="container my-5">
        <div className="row row-cols-1 row-cols-md-3 g-4">
          {/* Address Card */}
          <div className="col">
            <div className="contact-square-card">
              <i className="bi bi-geo-alt-fill icon-style"></i>
              <h5 className="card-title">Our Address</h5>
              <p className="card-subtitle">
                We’re available here for visits and meetings.
              </p>
              <p className="card-detail">
                KapelStraat 15, Bussum, The Netherlands
              </p>
              <button className="card-btn">View on Map</button>
            </div>
          </div>

          {/* Email Card */}
          <div className="col">
            <div className="contact-square-card">
              <i className="bi bi-envelope-fill icon-style"></i>
              <h5 className="card-title">Email Us</h5>
              <p className="card-subtitle">
                Reach out with your queries or proposals.
              </p>
              <p className="card-detail">namasteco.biz@gmail.com</p>
              <button className="card-btn">Send Email</button>
            </div>
          </div>

          {/* Phone Card */}
          <div className="col">
            <div className="contact-square-card">
              <i className="bi bi-telephone-fill icon-style"></i>
              <h5 className="card-title">Call Us</h5>
              <p className="card-subtitle">
                We’re happy to talk anytime during business hours.
              </p>
              <p className="card-detail">+31 357854597</p>
              <button className="card-btn">Call Now</button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid contact-section-blended py-5">
        <div className="container">
          <div className="row g-4 align-items-start justify-content-center">
            {/* Left Column: Map */}
            <div className="col-12 col-lg-6">
              <div className="map-container-blended">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2443.8932759128867!2d5.160753915800866!3d52.27205037976525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c61721d501f8a1%3A0x7f35eaf8a3b54e69!2sKapelstraat%2015%2C%201405%20BJ%20Bussum%2C%20Netherlands!5e0!3m2!1sen!2snl!4v1716275000000!5m2!1sen!2snl"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Company Location"
                ></iframe>
              </div>
            </div>

            {/* Right Column: Contact Form */}
            <div className="col-12 col-lg-6">
              <div className="contact-form-blended">
                <div className="form-header">
                  <h1>Get in Touch</h1>
                  <p>We'd love to hear from you. Drop us a message!</p>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>E-mail</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter Your Email Address"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Contact Number</label>
                    <input
                      type="text"
                      name="contact"
                      value={formData.contact}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter your Contact Number"
                    />
                  </div>
                  <div className="form-group">
                    <label>Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Enter Your Message"
                      className="form-control"
                      rows="3"
                      required
                    ></textarea>
                  </div>

                  <button type="submit" className="submit-button">
                    SUBMIT
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
